// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/agentManage',
    name: 'AgentManage',
    component: layout,
    redirect: '/agentManage/index',
    meta: {
      title: 'Agent 编辑模块',
      roles: [0]
    },
    // 排在订单管理（sort 7）上面
    sort: 6.5,
    children: [
      {
        path: 'index',
        name: 'AgentManageIndex',
        component: () => import('@/views/Manage/Agent/Index.vue'),
        meta: {
          title: 'Agent 编辑模块',
          icon: 'i-self:agent-robot',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
